import { z } from 'zod';

//* Define your environment variables schema here, so you get type safety throughout your app
export const EnvSchema = z.object({
  API_BASE_URL: z.string().url(), // API URL

  STORAGERESOURCENAME: z.string().optional().default(''), // Storage resource name (optional, for displaying existing images)
  STORAGE_CONTAINER: z.string().optional().default(''), // Storage container (optional, for displaying existing images)
});
